module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABWElEQVQ4T7WVPU/DMBCG75qKNGIIsEBBiJWRTyGhqkwX9RfkN6L8gtTu2K4tiIENUAVi4iNblMg5lJCW0kbEhOIlkvPe4/d89hkhH57nrdi2vWMYBk7mdL5KKQ6C4Ml13SjVT4OllEMAONSBFGiuiCiLnQVyLrwLw7BtWVaLmS91FyCijFUEHBBRq9vt7tdqtdvKQCHECyJu5IARAGwDwKYm8J2I1ucdpnvQQsRfFYWZ063qE1Fq4itlTSelsqkb3/ebhmEcVXGolBp2Op3nbw57vd4DM++lk8z8ioirAGCWWvoUjIkoi12oMiJeR1F0ZprmcZIkA00g/HRsbuI4Pm00GidKqX5loBBijIi7VVJm5kfHcbLY/yuKbmplutmiLPdgSynfAGBt5uo1AWCrzFH+v/DqTbrNcpqDlHICvK/X6+dKqYs/tS8hxAgRDzRTnJctNthlPQEf/CKyFWYV+n4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/middle_six.png
// module id = FCuv
// module chunks = 1